import React from "react";
import { string, object } from "prop-types";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import "./story-template-icon.m.css";

export const StoryTemplateIcon = ({ storyTemplate, iconSizes = { width: 16, height: 16 } }) => {
  const { width, height } = iconSizes;
  const style = {
    left: `calc(50% - ${width / 2}px)`,
    bottom: `calc(50% - ${height / 2}px)`,
  };
  switch (storyTemplate) {
    case "photo":
      return <SvgIconHandler styleName={`story-icon`} type="photo" height={height} width={width} />;
    case "video":
      return <SvgIconHandler styleName={`story-icon`} iconStyle={style} type="video" height={height} width={width} />;
    case "visual-story":
      return <SvgIconHandler styleName={`story-icon top-left`} type="portrait" height={height} width={width} />;
    default:
      return null;
  }
};

StoryTemplateIcon.propTypes = {
  storyTemplate: string,
  iconSizes: object,
};
